export default "__VITE_ASSET__Dem2y2Cg__"